const palette = {
  blue: '#00A1E3',
  blueDarker: '#0056B3',
  dark: '#0B1928',
  darkLighter: '#24303E',
  darkLightest: '#3C4753',
  gray: '#999999',
  grayBackground: '#F0F2F4',
  grayLight: '#D1D1D1',
  grayLighter: '#E0E0E0',
  grayLightest: '#F9F9F9',
  greenDark: '#6AA146',
  greenLightest: '#DDF5C7',
  redLight: '#FADDDD',
  redDark: '#BB3535'
};

const colors = {
  borderLight: palette.grayLight,
  gray100: palette.gray,
  gray50: palette.grayLighter,
  link: palette.blue,
  linkHover: palette.blueDarker,
  text: palette.dark,
  textSecondary: palette.gray,
  responseErrorBackground: palette.redLight,
  responseErrorTab: palette.redDark,
  responseSuccessBackground: palette.greenLightest,
  responseSuccessTab: palette.greenDark,
  rightPanelBackground: palette.dark,
  rightPanelBlockBackground: palette.darkLighter,
  rightPanelText: palette.grayLightest,
  sidebarActiveText: palette.blue,
  sidebarBackground: palette.grayBackground
};

export default colors;